import type { DefaultColor, Grayscale, ITheme } from "../../Theme/Theme.types.js";
import type { DefaultButtonProps } from "../Button.types.js";

function isThemeColor(theme: ITheme, color: string): color is keyof typeof theme.colors {
    return Object.keys(theme.colors).includes(color);
}
function isThemeValue(theme: ITheme, color: string, value: string): value is keyof DefaultColor {
    if (!isThemeColor(theme, color)) return false;
    return Object.keys(theme.colors[color]).includes(value);
}

function isGrayscaleColor(theme: ITheme, color: string): color is keyof Grayscale {
    return Object.keys(theme.grayscale).includes(color);
}

export const getColor = ({
    theme,
    color,
    value,
}: {
    theme: ITheme;
    color: DefaultButtonProps["color"];
    value: keyof DefaultColor | keyof Grayscale;
}): string | undefined => {
    if (color === "gradient") {
        if (Number(value) === 10) return theme.gradients.purpleToGreen10;
        return theme.gradients.purpleToGreen;
    }
    if (color === "blueMonday") return theme.gradients.blueMonday;
    if (color === "blackThirstday") return theme.gradients.blackThirstday;
    if (isThemeColor(theme, color) && isThemeValue(theme, color, value)) return theme.colors[color][value];
    return isGrayscaleColor(theme, value) ? theme.grayscale[value] : undefined;
};
